// Keep here all images referenced from ruby code so that Webpack knows about them.

// This will import all the static images from app/assets/images
require.context('../../assets/images', true)
